export function keyMilestones() {

    let $timeLine = $(".key-milestones .years-list");
    let $keyInfo = $(".key-milestones .description");
    let $year = $timeLine.find(".year");
    let dataSlide = 0;
    if ($timeLine.hasClass("selected")) {
        dataSlide = $timeLine.data("slide");
        $year.removeClass("active").eq(dataSlide).addClass("active");
    }
    $timeLine.slick({
        infinite: false,
        speed: 100,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: dataSlide,
        arrows: false,
        draggable: false,
        asNavFor: $keyInfo
    });
    $keyInfo.slick({
        draggable: false,
        infinite: false,
        speed: 100,
        slidesToShow: 1,
        initialSlide: dataSlide,
        fade: true,
        adaptiveHeight: true,
        appendArrows: ".key-milestones .sliders-nav",
        asNavFor: $timeLine
    });
    $timeLine.find(".slick-track").attr("role", "tablist");
    $timeLine.find(".slick-slide").each(function () {
        let $this = $(this);
        let button = $this.find("button");
        let yearIndex = $this.index();
        let thisContent = button.text();
        button.attr({
            role: "tab",
            "aria-selected": false,
            "aria-controls": thisContent + "TabPanel",
            "id": thisContent + "Tab"
        });
        let yearDescription = $keyInfo.find(".slick-slide").eq(yearIndex).find(".description-holder");
        yearDescription.attr({
            role: "tabpanel",
            "aria-labelledby": thisContent + "Tab",
            hidden: "hidden",
            tabindex: "-1",
            "id": thisContent + "TabPanel"
        });
    });
    $timeLine.find(".slick-current button").attr("aria-selected", "true");
    $keyInfo.find(".slick-current .description-holder").attr("tabindex", "0").removeAttr("hidden");

    $keyInfo.on("afterChange", function (event, slick, currentSlide, nextSlide) {
        $year.removeClass("active");
        setTimeout(function () {
            $year.find("button").attr({
                tabindex: "-1",
                "aria-selected": false
            });
            $keyInfo.find(".description-holder").attr({
                hidden: "hidden",
                tabindex: "-1"
            });
            $timeLine.find(".slick-slide").eq(currentSlide).find(".year").addClass("active").find("button").attr({
                tabindex: "0",
                "aria-selected": true
            }).focus();
            $keyInfo.find(".slick-slide").eq(currentSlide).find(".description-holder").attr("tabindex", "0").removeAttr("hidden");
        }, 100);
    });

    $(".slick-prev").on("click", function () {
        $(this).attr("disabled", "disabled");
        if ($(this).attr("disabled") === "disabled") {
            let index = $keyInfo.find(".slick-current").index();
            $timeLine.slick("slickGoTo", index);
        }
        setTimeout(() => {
            $(this).attr("disabled", false);
        }, 1000);

    });
    $(".slick-next").on("click", function () {
        $(this).attr("disabled", "disabled");
        if ($(this).attr("disabled") === "disabled") {
            $timeLine.slick("slickNext");
            setTimeout(() => {
                $(this).attr("disabled", false);
            }, 1000);
        }
    });

    $year.find("button").on("click", function () {
        if (!$(this).hasClass("active")) {
            let itemIndex = $(this).parents(".slick-slide").index();
            $keyInfo.slick("slickGoTo", itemIndex);
        }
    });

    $year.find("button").attr("tabindex", "-1");
    $timeLine.find(".slick-current button").attr("tabindex", "0");


    $timeLine.on("keydown", function (event) {
        let itemIndex = $timeLine.find(".slick-current").index();
        if (event.keyCode === 37) {
            if (itemIndex === 0) {
                $timeLine.slick("slickGoTo", $timeLine.find(".slick-slide").length - 1);
            }
        }
        if (event.keyCode === 39) {
            if (itemIndex === $timeLine.find(".slick-slide").length - 1) {
                $timeLine.slick("slickGoTo", 0);
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/keyMilestones.js